"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImUSDOracleFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var ImUSDOracleFactory = /** @class */ (function (_super) {
    __extends(ImUSDOracleFactory, _super);
    function ImUSDOracleFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    ImUSDOracleFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    ImUSDOracleFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    ImUSDOracleFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    ImUSDOracleFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    ImUSDOracleFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return ImUSDOracleFactory;
}(contracts_1.ContractFactory));
exports.ImUSDOracleFactory = ImUSDOracleFactory;
var _abi = [
    {
        constant: true,
        inputs: [],
        name: "fetchCurrentPrice",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                ],
                internalType: "struct Decimal.D256",
                name: "",
                type: "tuple",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "imUSDAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "mUSDCrvPoolAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "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";
